import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import { initTracking } from "@/lib/tracking";
import { SiteConfigContext, applyTheme } from "@/context/SiteConfigContext";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustBar } from "@/components/landing/TrustBar";
import { Marquee } from "@/components/landing/Marquee";
import { Certifications } from "@/components/landing/Certifications";
import { GasBillBanner } from "@/components/landing/GasBillBanner";
import { Signs } from "@/components/landing/Signs";
import { Risks } from "@/components/landing/Risks";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Services } from "@/components/landing/Services";
import { Safety } from "@/components/landing/Safety";
import { About } from "@/components/landing/About";
import { Stats } from "@/components/landing/Stats";
import { Testimonials } from "@/components/landing/Testimonials";
import { Coverage } from "@/components/landing/Coverage";
import { Faq } from "@/components/landing/Faq";
import { Blog } from "@/components/landing/Blog";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";

export default function Landing() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const onMsg = (e) => {
      if (e.origin !== window.location.origin) return;
      if (e.data?.type !== "manutentudo-theme-preview") return;
      applyTheme(e.data.payload);
      setConfig(e.data.payload);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  useEffect(() => {
    api.get("/tracking").then((r) => initTracking(r.data)).catch(() => {});
    api
      .get("/site-config")
      .then((r) => {
        applyTheme(r.data);
        setConfig(r.data);
      })
      .catch(() => {});
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      <div className="bg-white" data-testid="landing-page">
        <Navbar />
        <Hero />
        <TrustBar />
        <Marquee />
        <Certifications />
        <Signs />
        <GasBillBanner />
        <Risks />
        <HowItWorks />
        <Services />
        <Safety />
        <About />
        <Stats />
        <Testimonials />
        <Coverage />
        <Faq />
        <Blog />
        <Contact />
        <Footer />
        <FloatingWhatsApp />
      </div>
    </SiteConfigContext.Provider>
  );
}
